import { defineComponent, ExtractPropTypes } from 'vue';
import { createNamespaceBem, makeCustomProp, makeStringProp, numericProp } from '@/utils';
import {
  Field,
  type FieldProps as VanFieldProps,
  type FieldType as VanFieldType,
  type FieldTextAlign as VanFieldTextAlign,
} from 'vant';

const { name } = createNamespaceBem('field');

const fieldProps = {
  name: makeStringProp<VanFieldProps['name']>(''),
  label: makeStringProp<VanFieldProps['label']>(''),
  disabled: makeCustomProp<VanFieldProps['disabled']>(Boolean, false),
  readonly: makeCustomProp<VanFieldProps['readonly']>(Boolean, false),
  autosize: makeCustomProp<VanFieldProps['autosize']>(Boolean, false),
  type: makeStringProp<VanFieldType>('text'),
  rows: numericProp,
  inputAlign: makeCustomProp<VanFieldTextAlign>(String, 'left'),
  rules: makeCustomProp<VanFieldProps['rules']>(Array, []),
  isLink: makeCustomProp<VanFieldProps['isLink']>(Boolean, false),
  placeholder: makeStringProp<VanFieldProps['placeholder']>('请输入'),
};

export type FieldProps = ExtractPropTypes<typeof fieldProps>;

export default defineComponent({
  name,

  props: fieldProps,

  emits: ['fieldClick'],

  setup(props, { emit }) {
    const triggerPicker = () => {
      if (props.disabled || props.readonly) return;
      emit('fieldClick');
    };

    return () => (
      <Field
        id={props.name}
        name={props.name}
        label={props.label}
        type={props.type}
        rows={props.rows}
        autosize={props.autosize}
        input-align={props.inputAlign}
        disabled={props.disabled}
        readonly={props.readonly}
        rules={props.rules}
        is-link={props.isLink}
        placeholder={props.placeholder ?? '请输入'}
        onClick={triggerPicker}
      />
    );
  },
});
